var UNKNOWN = 'UNKNOWN';

function _unknownIfNull(s) {
  return s ? s : UNKNOWN;
}

function _zeroIfNull(l) {
  return l ? l : 0;
}

export function buildKey(impression) {
  return "".concat(_unknownIfNull(impression.keyName), "\n    :").concat(_unknownIfNull(impression.feature), "\n    :").concat(_unknownIfNull(impression.treatment), "\n    :").concat(_unknownIfNull(impression.label), "\n    :").concat(_zeroIfNull(impression.changeNumber));
}


// WEBPACK FOOTER //
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@splitsoftware/splitio-react/es/splitio/impressions/hasher/index.js